import {Contact} from "../../../model/Contact";
import {ContactProfileController, ContactProfileControllerScope} from "../ContactProfileController";
import {IPromise} from "angular";
import {Page, Pageable} from "../../../../utils/models/Page";
import {CampaignActionLogService} from "../../../../campaigns_service/service/CampaignActionLogService";
import {CampaignActionLog} from "../../../../campaigns_service/model/CampaignActionLog";

export interface ConversionLogAwareContactProfileScope<T extends Contact> extends ContactProfileControllerScope<T>{
    campaignLogs?: CampaignActionLog[];
    fetchCustomerCampaignLogs: () => IPromise<void>
    campaignLogPagingConfig: Pageable;
}

export abstract class ConversionLogAwareContactProfileController<T extends Contact, S extends ConversionLogAwareContactProfileScope<T>>
    extends ContactProfileController<T, S> {


    constructor($scope: S,
                $routeParams: ng.route.IRouteParamsService,
                selectedContact: T,
                protected campaignActionLogService: CampaignActionLogService) {
        super($scope, $routeParams, selectedContact);
        $scope.fetchCustomerCampaignLogs = () => {
            let pageConfig = this.$scope.campaignLogPagingConfig;
            return this.campaignActionLogService.fetchCustomerCampaignActionLog($scope.selectedContact.id,
                pageConfig.page - 1,
                pageConfig.pageSize)
                .then(resp => {
                    if (resp.status === 200) {
                        let page = resp.data;
                        $scope.campaignLogs = page.content;
                        this.updatePagingConfig(page, $scope.campaignLogPagingConfig);
                    }
                })
        };

        $scope.campaignLogPagingConfig = this.initPagingConfig($scope.fetchCustomerCampaignLogs);
        $scope.fetchCustomerCampaignLogs();
    }

    protected initPagingConfig(fetchPage): Pageable {
        return {
            page: 1,
            pageSize: 10,
            totalElements: 0,
            fetchPage: fetchPage
        };
    }

    protected updatePagingConfig(page: Page<any>, pageable: Pageable) {
        pageable.page = (page.number + 1);
        pageable.totalElements = page.totalElements;
        pageable.pageSize = page.size;
    }

}